const messages = {
  en: {
    translations: {
      signup: {
        title: 'Sign up',
        toasts: {
          success: 'Sign up successful! Log in to access the system.',
          fail: 'Error creating user. Check the reported data.',
        },
        form: {
          name: 'Name',
          email: 'Email',
          password: 'Password',
        },
        buttons: {
          submit: 'Register',
          login: 'Already have an account? Log in!',
        },
      },
      login: {
        title: 'Login',
        form: {
          email: 'Email',
          password: 'Password',
        },
        buttons: {
          submit: 'Enter',
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: 'Login successfully!',
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: 'Tickets today: ',
          },
        },
      },
      contactImportWpModal: {
        title: 'Export Contacts to Excel',
        exportSuccess: 'Export completed successfully!',
        buttons: {
          downloadModel: 'Download Excel template for import',
          closed: 'Close',
          import: 'Select the Excel file to import Contacts',
        },
      },
      connections: {
        title: 'Connections',
        toasts: {
          deleted: 'WhatsApp connection deleted sucessfully!',
          disconnected: 'Connection disconnected successfully!',
        },
        facebook: {
          success: 'Facebook/Instagram connection connected successfully!',
          errorConfig: 'Facebook configuration not available.',
          connecting: 'Connecting...',
          redirecting: 'Redirecting...',
          errorRedirect: 'Error. Redirecting...',
          errorNoUserId: 'Could not get user ID.',
          popupBlocked: 'Popup blocked. Please allow popups for this site and try again.',
        },
        meta: {
          openAuth: 'Authorization window opened. Complete the flow.',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: 'Are you sure? It cannot be reverted.',
          disconnectTitle: 'Disconnect',
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
          disconnectMetaMessage:
            'Are you sure? The Facebook/Instagram integration will be disconnected.',
        },
        buttons: {
          add: 'Add WhatsApp',
          disconnect: 'Disconnect',
          tryAgain: 'Try Again',
          qrcode: 'QR CODE',
          newQr: 'New QR CODE',
          connecting: 'Connectiing',
        },
        toolTips: {
          disconnected: {
            title: 'Failed to start WhatsApp session',
            content:
              'Make sure your cell phone is connected to the internet and try again, or request a new QR Code',
            titleMeta: 'Failed to connect with Facebook/Instagram',
            contentMeta:
              'The connection with Facebook or Instagram was lost. Click reconnect to reauthorize.',
          },
          qrcode: {
            title: 'Waiting for QR Code read',
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: 'Connection established',
          },
          timeout: {
            title: 'Connection with cell phone has been lost',
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: 'Name',
          status: 'Status',
          lastUpdate: 'Last Update',
          default: 'Default',
          actions: 'Actions',
          session: 'Session',
        },
      },
      whatsappModal: {
        title: {
          add: 'Add WhatsApp',
          edit: 'Edit WhatsApp',
        },
        form: {
          name: 'Name',
          default: 'Default',
          importMax30Days: 'The import period cannot exceed 30 days',
          importMax30DaysHint: 'Maximum 30 days between dates',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
        menuItem: {
          disabled: 'Disabled',
        },
        success: 'WhatsApp saved successfully.',
      },
      qrCode: {
        message: 'Read QrCode to start the session',
      },
      contacts: {
        title: 'Contacts',
        toasts: {
          deleted: 'Contact deleted sucessfully!',
        },
        searchPlaceholder: 'Search ...',
        confirmationModal: {
          deleteTitle: 'Delete',
          importTitlte: 'Import contacts',
          deleteMessage:
            'Are you sure you want to delete this contact? All related tickets will be lost.',
          importMessage: 'Do you want to import all contacts from the phone?',
        },
        buttons: {
          import: 'Import Contacts',
          add: 'Add Contact',
        },
        table: {
          name: 'Name',
          whatsapp: 'WhatsApp',
          email: 'Email',
          actions: 'Actions',
        },
      },
      contactModal: {
        title: {
          add: 'Add contact',
          edit: 'Edit contact',
        },
        form: {
          mainInfo: 'Contact details',
          extraInfo: 'Additional information',
          name: 'Name',
          number: 'Whatsapp number',
          email: 'Email',
          extraName: 'Field name',
          extraValue: 'Value',
        },
        buttons: {
          addExtraInfo: 'Add information',
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
        success: 'Contact saved successfully.',
      },
      queueModal: {
        title: {
          add: 'Add queue',
          edit: 'Edit queue',
        },
        form: {
          name: 'Name',
          color: 'Color',
          greetingMessage: 'Greeting Message',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
      },
      userModal: {
        title: {
          add: 'Add user',
          edit: 'Edit user',
        },
        form: {
          name: 'Name',
          email: 'Email',
          password: 'Password',
          profile: 'Profile',
        },
        buttons: {
          okAdd: 'Add',
          okEdit: 'Save',
          cancel: 'Cancel',
        },
        success: 'User saved successfully.',
      },
      chat: {
        noTicketMessage: 'Select a ticket to start chatting.',
      },
      ticketsManager: {
        buttons: {
          newTicket: 'New',
        },
      },
      ticketsQueueSelect: {
        placeholder: 'Queues',
      },
      tickets: {
        toasts: {
          deleted: 'The ticket you were on has been deleted.',
        },
        notification: {
          message: 'Message from',
        },
        tabs: {
          open: { title: 'Inbox' },
          closed: { title: 'Resolved' },
          search: { title: 'Search' },
        },
        search: {
          placeholder: 'Search tickets and messages.',
        },
        buttons: {
          showAll: 'All',
          quickmessageflash: 'Quick Message',
        },
        confirmationModal: {
          deleteTitle: 'Delete ticket',
          deleteMessage: 'Do you really want to delete this ticket?',
          closeTitle: 'Close ticket',
          closeMessage: 'Do you really want to close this ticket?',
          ignoreTitle: 'Ignore ticket',
          ignoreMessage: 'Do you really want to ignore this ticket?',
        },
      },
      transferTicketModal: {
        title: 'Transfer Ticket',
        subtitle: 'Pick an agent (optional) and the destination queue.',
        close: 'Close',
        fieldLabel: 'Type to search for users',
        fieldQueueLabel: 'Transfer to queue',
        fieldQueuePlaceholder: 'Select a queue',
        noOptions: 'No user found with this name',
        buttons: {
          ok: 'Transfer',
          cancel: 'Cancel',
        },
      },
      messageInput: {
        tooltip: {
          signature: 'Enable/disable signature',
          privateMessage: 'Enable/disable private message',
          meet: 'Send video call link',
        },
        type: {
          attachFile: 'Attach file',
          imageVideo: 'Photos & videos',
          cam: 'Camera',
          document: 'Document',
          contact: 'Contact',
          meet: 'Video call',
          privateMessage: 'Private message',
          scheduleMessage: 'Schedule message',
          moreOptions: 'More options',
          moreOptionsDetail: 'More options (buttons, lists, etc.)',
          quickMessages: 'Quick messages',
          signature: 'Signature (agent name)',
          emojis: 'Emojis',
        },
      },
      quickMessages: {
        pickerEmpty: 'No quick messages saved yet.',
        noTextPreview: '(no text)',
        dialog: {
          subtitle: 'Create message shortcuts for your team.',
          insertEmoji: 'Insert emoji',
          removeAttachment: 'Remove file',
        },
      },
      ticketsList: {
        pendingHeader: 'Queue',
        assignedHeader: 'Working on',
        noTicketsTitle: 'Nothing here!',
        noTicketsMessage: 'No tickets found with this status or search term.',
        buttons: {
          accept: 'Accept',
        },
      },
      newTicketModal: {
        title: 'Create Ticket',
        fieldLabel: 'Type to search for a contact',
        add: 'Add',
        buttons: {
          ok: 'Save',
          cancel: 'Cancel',
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: 'Dashboard',
          connections: 'Connections',
          tickets: 'Tickets',
          contacts: 'Contacts',
          queues: 'Queues',
          administration: 'Administration',
          users: 'Users',
          settings: 'Settings',
        },
        appBar: {
          user: {
            profile: 'Profile',
            logout: 'Logout',
          },
        },
      },
      notifications: {
        noTickets: 'No notifications.',
      },
      queues: {
        title: 'Queues',
        table: {
          name: 'Name',
          color: 'Color',
          greeting: 'Greeting message',
          actions: 'Actions',
        },
        buttons: {
          add: 'Add queue',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage:
            'Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.',
        },
      },
      queueSelect: {
        inputLabel: 'Queues',
      },
      users: {
        title: 'Users',
        table: {
          name: 'Name',
          email: 'Email',
          profile: 'Profile',
          actions: 'Actions',
        },
        buttons: {
          add: 'Add user',
        },
        toasts: {
          deleted: 'User deleted sucessfully.',
        },
        confirmationModal: {
          deleteTitle: 'Delete',
          deleteMessage: "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: 'Settings saved successfully.',
        title: 'Settings',
        settings: {
          userCreation: {
            name: 'User creation',
            options: {
              enabled: 'Enabled',
              disabled: 'Disabled',
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: 'Assigned to:',
          buttons: {
            return: 'Return',
            resolve: 'Resolve',
            reopen: 'Reopen',
            accept: 'Accept',
          },
        },
      },
      messagesInput: {
        placeholderOpen: 'Type a message',
        placeholderClosed: 'Reopen or accept this ticket to send a message.',
        signMessage: 'Sign',
      },
      contactDrawer: {
        header: 'Contact details',
        buttons: {
          edit: 'Edit contact',
        },
        extraInfo: 'Other information',
      },
      ticketOptionsMenu: {
        delete: 'Delete',
        transfer: 'Transfer',
        confirmationModal: {
          title: 'Delete ticket #',
          titleFrom: 'from contact ',
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: 'Delete',
          cancel: 'Cancel',
        },
      },
      confirmationModal: {
        buttons: {
          confirm: 'Confirm',
          cancel: 'Cancel',
        },
      },
      messageOptionsMenu: {
        delete: 'Delete',
        reply: 'Reply',
        edit: 'Edit',
        forward: 'Forward',
        toForward: 'Forward',
        talkTo: 'Talk to',
        copyMessage: 'Copy message',
        copySuccess: 'Message copied!',
        copyNoText: 'This message has no text to copy.',
        confirmationModal: {
          title: 'Delete message?',
          message: 'This action cannot be reverted.',
        },
      },
      import: {
        page: {
          title: 'Imports',
          subtitle: 'Track WhatsApp and Meta (Facebook/Instagram) history imports',
        },
        buttons: {
          refresh: 'Refresh',
          startMeta: 'Import history (Meta)',
          backToConnections: 'Back to Connections',
        },
        emptyState: 'No imports found',
        toasts: {
          started: 'Import started',
          finished: 'Import finished',
        },
        metaModal: {
          title: 'Import history (Meta)',
          hint: 'If token is empty, the backend uses the token saved in the connection.',
          selectConnection: 'Select connection',
          selectConnectionRequired: 'Select a connection',
          loadingConnections: 'Loading connections...',
          noConnections: 'No Meta connections found',
          pageIdRequired: 'Page ID is required',
          dateStart: 'Start date',
          dateEnd: 'End date',
        },
        banner: {
          importing: 'Importing history…',
          viewDetails: 'View details',
        },
        tooltips: {
          whatsappAuto: 'WhatsApp imports automatically after connecting',
          metaRateLimit: 'Meta depends on permissions and rate limit.',
        },
      },
      campaigns: {
        buttons: {
          add: 'New campaign',
          addPhrase: 'New phrase campaign',
        },
      },
      backendErrorTokens: {
        ACCESS: 'access',
        ACTIVE: 'active',
        ANNOUNCEMENT: 'announcement',
        API: 'API',
        APP: 'app',
        APPOINTMENT: 'appointment',
        AUTH: 'authentication',
        AUTOMATION: 'automation',
        BRL: 'BRL',
        CAMPAIGN: 'campaign',
        CHAT: 'chat',
        CHATBOT: 'chatbot',
        CLIENT: 'client',
        CODE: 'code',
        COMPANY: 'company',
        CONFIGURED: 'configured',
        CONNECTION: 'connection',
        CONTACT: 'contact',
        CREDENTIALS: 'credentials',
        CREATION: 'creation',
        DELETE: 'deletion',
        DISABLED: 'disabled',
        DUPLICATED: 'duplicated',
        EMAIL: 'email',
        EXPIRED: 'expired',
        EXTERNAL: 'external',
        FACEBOOK: 'Facebook',
        FATURA: 'invoice',
        FETCH: 'fetch',
        FORBIDDEN: 'forbidden',
        FOUND: 'found',
        INACTIVE: 'inactive',
        INTEGRATIONS: 'integrations',
        INTERNAL: 'internal',
        INVALID: 'invalid',
        MEDIA: 'media',
        MESSAGE: 'message',
        MISSING: 'missing',
        NAME: 'name',
        NO: 'no',
        NOT: 'not',
        OPENAI: 'OpenAI',
        PASSWORD: 'password',
        PERMISSION: 'permission',
        PLAN: 'plan',
        PROJECT: 'project',
        QUEUE: 'queue',
        REQUIRED: 'required',
        ROUTE: 'route',
        SENDING: 'sending',
        SERVICE: 'service',
        SESSION: 'session',
        SUBSCRIPTION: 'subscription',
        TAG: 'tag',
        TASK: 'task',
        TICKET: 'ticket',
        TOKEN: 'token',
        USER: 'user',
        VALIDATION: 'validation',
        VALUE: 'value',
        WAPP: 'WhatsApp',
        WHATSAPP: 'WhatsApp',
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: 'There must be at lest one default WhatsApp connection.',
        ERR_NO_DEF_WAPP_FOUND: 'No default WhatsApp found. Check connections page.',
        ERR_WAPP_NOT_INITIALIZED:
          'This WhatsApp session is not initialized. Check connections page.',
        ERR_WAPP_CHECK_CONTACT: 'Could not check WhatsApp contact. Check connections page.',
        ERR_WAPP_INVALID_CONTACT: 'This is not a valid whatsapp number.',
        ERR_WAPP_DOWNLOAD_MEDIA: 'Could not download media from WhatsApp. Check connections page.',
        ERR_INVALID_CREDENTIALS: 'Authentication error. Please try again.',
        ERR_INVALID_TOKEN: 'Invalid token. Please login again.',
        ERR_SENDING_WAPP_MSG: 'Error sending WhatsApp message. Check connections page.',
        ERR_SENDING_FACEBOOK_MSG: 'Error sending Facebook/Instagram message. Check the connection.',
        instagram_does_not_support_this_media_type:
          'Instagram does not support this file type. Please send JPEG, PNG, GIF, or WEBP images only.',
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: 'Session expired. Please login.',
        ERR_NO_AUTH_TOKEN: 'Request without authorization token. Please login again.',
        ERR_ACCESS_TOKEN_EXPIRED: 'Access token expired. Refresh the page or login again.',
        ERR_REFRESH_TOKEN_MISSING: 'Refresh token missing. Please login again.',
        ERR_REFRESH_TOKEN_EXPIRED: 'Refresh token expired. Please login again.',
        ERR_REFRESH_TOKEN_INVALID: 'Refresh token invalid. Please login again.',
        ERR_SESSION_REVOKED:
          'Session revoked (e.g. logout from another device). Please login again.',
        ERR_AUTH_REQUIRED: 'Authentication required. Please login to continue.',
        ERR_APP_NOT_ACTIVE:
          'The app or integration is not active. Check your settings or contact support.',
        ERR_PLAN_INTERNAL_CHAT_DISABLED:
          "Internal chat is not available for the company's current plan.",
        ERR_PLAN_INTEGRATIONS_DISABLED:
          "Integrations are not available for the company's current plan.",
        ERR_COMPANY_APP_ALREADY_CANCELLED: 'This app has already been deactivated.',
        ERR_COMPANY_TOKEN_MISSING: 'Company token not provided.',
        ERR_COMPANY_TOKEN_NOT_CONFIGURED: 'Company token not configured on server.',
        ERR_COMPANY_TOKEN_INVALID: 'Invalid company token.',
        ERR_API_TOKEN_MISSING: 'API token not provided.',
        ERR_API_TOKEN_NOT_CONFIGURED: 'Integration token not configured.',
        ERR_API_TOKEN_INVALID: 'Invalid API token.',
        ERR_USER_CREATION_DISABLED: 'User creation was disabled by administrator.',
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: 'A contact with this number already exists.',
        ERR_NO_SETTING_FOUND: 'No setting found with this ID.',
        ERR_NO_CONTACT_FOUND: 'No contact found with this ID.',
        ERR_NO_TICKET_FOUND: 'No ticket found with this ID.',
        ERR_NO_USER_FOUND: 'No user found with this ID.',
        ERR_NO_WAPP_FOUND: 'No WhatsApp found with this ID.',
        ERR_CREATING_MESSAGE: 'Error while creating message on database.',
        ERR_CREATING_TICKET: 'Error while creating ticket on database.',
        ERR_FETCH_WAPP_MSG: 'Error fetching the message in WhtasApp, maybe it is too old.',
        ERR_QUEUE_COLOR_ALREADY_EXISTS: 'This color is already in use, pick another one.',
        ERR_WAPP_GREETING_REQUIRED: 'Greeting message is required if there is more than one queue.',
        ERR_EMAIL_ALREADY_EXISTS: 'This email is already registered. Use another one or log in.',
        ERR_COMPANY_NAME_ALREADY_EXISTS: 'This company name is already registered.',
        ERR_COMPANY_DOCUMENT_ALREADY_EXISTS: 'This company document is already registered.',
        ERR_UNIQUE_CONSTRAINT_VIOLATION:
          'A record with this value already exists. Check the fields and try again.',
        ERR_META_IMPORT_TOKEN_MISSING:
          'Connect the page in Settings > Connections before importing.',
        ERR_META_IMPORT_PAGE_NOT_FOUND: 'Page not found. Link the page in Settings > Connections.',
        ERR_ROUTE_NOT_FOUND: 'Route or resource not found. Check the address or try again.',
        ERR_CREATING_FOLLOW_UP: 'Could not create follow-up. Check the data and try again.',
        ERR_PASSWORD_RESET_CODE_INVALID:
          'Invalid or expired code. Check the code or request a new one.',
        ERR_PROMPT_INTELLIGENCE_INVALID:
          "This prompt's intelligence settings are invalid. Check the model, tools, and required fields.",
        missing_code_or_state: 'Authorization cancelled or expired. Please try again.',
        invalid_or_expired_state: 'Authorization session expired. Please start the process again.',
        no_pages_found:
          'Your account does not manage any Facebook Page. To use Messenger or Instagram chat, you need to be an admin of a Facebook Page.',
        subscribe_failed:
          'Page connected, but the webhook was not activated. Make sure the app is in Live mode.',
        token_exchange_failed: 'Error authenticating the page. Please try reconnecting.',
        conflict:
          'This page is already in use by another account. Disconnect it before continuing.',
      },
    },
  },
};

export { messages };
